



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Outlet } from '@/models/Outlet';
import { CustomField, CustomFieldData } from '@/models/Contact';
import DynamicForm from '@/components/Form/DynamicForm.vue';
import http from '@/services/Http';
import { websiteText } from '@/mixins/websiteTexts';

declare var grecaptcha: any;

@Component({
    components: {
        DynamicForm
    }
})
class OutletContactForm extends Vue {
    @Prop() private outlet!: Outlet;
    
    showForm: boolean = true;
    isSubmitting: boolean = false;
    errorMsgs: string[] = [];

    websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    get formSchema(): CustomField[] {
        return [
            { placeholder: this.websiteText('retailer.firstname'), fieldType: 'TextField', mandatory: true, tabIndex: 1 },
            { placeholder: this.websiteText('retailer.lastname'), fieldType: 'TextField', mandatory: true, tabIndex: 2 },
            { placeholder: this.websiteText('retailer.email'), fieldType: 'EmailField', mandatory: true, tabIndex: 3 },
            { placeholder: this.websiteText('retailer.telephone'), fieldType: 'TextField', mandatory: true, tabIndex: 4 }
        ];
    }

    handleFormSubmit(formData: CustomFieldData[]) {
        this.errorMsgs = [];
        this.isSubmitting = true;
        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        grecaptcha.ready(() => {
            grecaptcha
                .execute(recaptchaSiteKey, { action: 'submit' })
                .then((token: string) => {
                    this.executeApiCall(token, formData);
                })
                .catch(() => {
                    this.isSubmitting = false;
                    this.errorMsgs.push('ReCAPTCHA failed. Please try again.');
                });
        });
    }

    private executeApiCall(token: string, formData: CustomFieldData[]) {
        const mappedPayload = {
            firstName: formData[0].value,
            lastName: formData[1].value,
            email: formData[2].value,
            phone: formData[3].value,
            name: this.outlet.Name,
            url: this.outlet.Url,
            id: this.outlet.Retailer.Id,
            token: token
        };

        http.post(`/api/contactform/outlet`, mappedPayload)
            .then(() => {
                this.showForm = false;
            })
            .catch((err: string) => {
                console.error('Error sending outlet form:', err);
                this.errorMsgs.push(this.websiteText('site.contactform.error_generic') || 'An error occurred. Please try again.');
            })
            .finally(() => {
                this.isSubmitting = false;
            });
    }
}
export default OutletContactForm;
